// extracted by mini-css-extract-plugin
module.exports = {"sitat":"dh-sk-sitat","sitat--right":"dh-sk-sitat--right","sitat__text":"dh-sk-sitat__text","sitat--left":"dh-sk-sitat--left"};